import React from "react";

const MiniLoader = () => {
  return (
    <div className=" flex  items-center justify-center ">
      <span className="loading loading-spinner w-10 text-primary"></span>
    </div>
  );
};

export default MiniLoader;
